module.exports = __webpack_public_path__ + "img/icon-copy.68f16cac.svg";